// styles
import './scss/app';

// js
import particleJS from 'particles.js';
import './import-images';
import './import-fonts';
import 'what-input';
import cowDozer from './js/cow-dozer';
import konami from './js/konami';
import scrollToShow from './scroll-to-show';
import setupNav from './js/nav';
import FontFaceObserver from './js/fontfaceobserver';

import CowLogic from './js/cow';
import d from './decrypt';
import setupSpaceCow from './js/space-cow';

$(document).on('turbolinks:load', function (e) {
  $(this).foundation();
  // Clear any open-drawer scroll lock left on <html> by the previous page.
  // Turbolinks swaps <body> but keeps <html>, so navigating via a drawer link
  // would otherwise carry `zurb-nav-open` (overflow:hidden) into the new page.
  $('html').removeClass('menu-open zurb-nav-open');

  // CSRF
  $.ajaxSetup({
    headers: {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
    },
  });

  // Carousels marked data-advance-on-click step forward when a slide is
  // clicked — each one only moves itself.
  $('[data-advance-on-click] .orbit-slide').click(function () {
    $(this).closest('[data-orbit]').foundation('changeSlide', true);
  });

  var pdpRunOnce = false;
  if ($('#pdpScrollContainer').length > 0) {
    $(document).scroll(function () {
      var pdpScrollContainer = document.getElementById('pdpScrollContainer');
      var offsetTop = $(pdpScrollContainer).offset().top;
      var offsetGap = 500;

      if (window.scrollY > offsetTop - offsetGap && !pdpRunOnce) {
        $(pdpScrollContainer).addClass('scroll-to-bottom');
        pdpRunOnce = true;
      }
    });
  }

  if ($('#particles-js').is('*')) {
    // Hack to get particles to render **usually** better.
    // Wait 1s to initialize the particles then it will fade in with a 2s fade
    setTimeout(function () {
      particlesJS.load('particles-js', '/particles.json', function () {
        // Override colors to grayscale after load
        if (window.pJSDom && window.pJSDom[0] && window.pJSDom[0].pJS) {
          var pJS = window.pJSDom[0].pJS;
          var grayscaleColors = [
            '#ffffff',
            '#e0e0e0',
            '#c0c0c0',
            '#a0a0a0',
            '#808080',
            '#606060',
          ];
          pJS.particles.color.value = grayscaleColors;
          pJS.particles.color.random = true;
          pJS.fn.particlesRefresh();
        }
      });
    }, 1000);
  }

  var pnLight = new FontFaceObserver('Proxima Nova Light');
  var pnReg = new FontFaceObserver('Proxima Nova Regular');
  var pnSem = new FontFaceObserver('Proxima Nova Regular');
  var pnBold = new FontFaceObserver('Proxima Nova Bold');
  var pnExBold = new FontFaceObserver('Proxima Nova Extra Bold');
  var heroes = new FontFaceObserver('Heroes');

  Promise.all([
    pnLight.load(),
    pnReg.load(),
    pnSem.load(),
    pnBold.load(),
    pnExBold.load(),
    heroes.load(),
  ]).then(function () {
    $('#particles-js').addClass('is-loaded');
    document.documentElement.className += ' fonts-loaded';
  });

  setTimeout(function () {
    document.documentElement.className += ' fonts-loaded';
  }, 3000);

  // navigation
  setupNav();

  // subscriber form (blog)
  $('form#subscriberForm').submit(function (e) {
    e.preventDefault();
    var $form = $(this);

    $.post('/api/subscribers', $form.serialize())
      .done(function (lead) {
        $form.html("<h3>Thanks! We'll be in touch soon!</h3>");
      })
      .fail(function (error) {
        console.log('error!', error);
      });
  });

  // wired submission
  $('form#wired-form').submit(function (e) {
    e.preventDefault();
    var $form = $(this);

    $.post('/api/wired_applicants', $form.serialize())
      .done(function (resp) {
        $('#wired-form-section').html(resp.template);
      })
      .fail(function (error) {
        alert('Something went wrong. Try again, or email getstarted@zurb.com');
      });
  });
  // Radar-style slide-in nav drawer (replaces the old Foundation burger).
  var $navDrawer = $('#zurb-nav-drawer');
  var navLastFocus = null;
  function navFocusable() {
    // Tabbable elements inside the drawer (the backdrop is tabindex="-1").
    return $navDrawer.find('a[href], button:not([disabled])').not('[tabindex="-1"]').filter(':visible');
  }
  function openNavDrawer() {
    navLastFocus = document.activeElement;
    $navDrawer.prop('hidden', false);
    $('html').addClass('zurb-nav-open');
    $('.zurb-nav-toggle').attr('aria-expanded', 'true');
    navFocusable().first().trigger('focus'); // move focus into the dialog
  }
  function closeNavDrawer() {
    if ($navDrawer.prop('hidden')) return;
    $navDrawer.prop('hidden', true);
    $('html').removeClass('zurb-nav-open');
    $('.zurb-nav-toggle').attr('aria-expanded', 'false');
    if (navLastFocus && navLastFocus.focus) navLastFocus.focus(); // restore focus to the opener
  }
  $(document).on('click', '.zurb-nav-toggle', openNavDrawer);
  $(document).on('click', '.zurb-nav-close, .zurb-nav-backdrop', closeNavDrawer);
  // Close the drawer (release the scroll lock) as soon as a link is clicked, so
  // the panel doesn't linger over the destination while Turbolinks navigates.
  $(document).on('click', '.zurb-nav-link', closeNavDrawer);
  $(document).on('keydown', function (e) {
    if ($navDrawer.prop('hidden')) return;
    if (e.key === 'Escape') {
      closeNavDrawer();
      return;
    }
    if (e.key === 'Tab') {
      // Trap focus within the open drawer so keyboard users can't tab behind it.
      var $f = navFocusable();
      if (!$f.length) return;
      var first = $f[0];
      var last = $f[$f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  scrollToShow();

  // Blog code samples: fetch Prism only on pages that have one.
  var postBody = document.querySelector('.main-content-column');
  if (postBody && postBody.querySelector('pre[class*="language-"]')) {
    import(/* webpackChunkName: "code-highlight" */ './js/code-highlight').then(function (mod) {
      mod.default(postBody);
    });
  }
});
d(function (cowKeys) {
  // DA COWS
  CowLogic.setup();
  konami(cowKeys);
  cowDozer(cowKeys);
  setupSpaceCow(cowKeys);

  $('#the-cow').click(function () {
    $('#beamButton').addClass('shake');
    setTimeout(function () {
      $('#beamButton').removeClass('shake');
    }, 1000);
  });

  $('#holy-cow').click(function () {
    window.COW.unlock('b60c5f4d-a8ef-4b13-b02f-887c14e3efdf', cowKeys);
  });
  //bike cow
  $(
    'img[src="https://zurb-dot-com-prod.s3.amazonaws.com/asset/595/raw_2F87045029-930d-41f9-85d3-891c312f7dd3_2Fcow-design.png"]'
  ).click(function () {
    window.COW.unlock('46a491e1-0a19-46cd-b45f-99cb63409d39', cowKeys);
  });

  // contact form (lead generation)
  $('form#leadForm').submit(function (e) {
    e.preventDefault();
    var $form = $(this);

    var afterLead = function () {
      $('.cow-section').addClass('is-beaming');
      $('.hide-me').addClass('is-opacity-zero');
      setTimeout(function () {
        $('.hide-me').addClass('is-visibility-hidden');
      }, 1000);
      setTimeout(function () {
        window.COW.unlock('7dd823bd-1762-45ce-ba99-b5ec8105855c', cowKeys);
      }, 7000);
    };
    $.post('/api/leads', $form.serialize())
      .done(function (lead) {
        afterLead();
      })
      .fail(function (error) {
        if (error.status == 422) {
          afterLead();
        } else {
          console.log('error!', error);
        }
      });
  });

  $(document).on('turbolinks:load', function () {
    CowLogic.setup();
    setupSpaceCow(cowKeys);
    // contact form (lead generation)
    $('form#leadForm').submit(function (e) {
      e.preventDefault();
      var $form = $(this);

      var afterLead = function () {
        $('.cow-section').addClass('is-beaming');
        $('.hide-me').addClass('is-opacity-zero');
        setTimeout(function () {
          $('.hide-me').addClass('is-visibility-hidden');
        }, 1000);
        setTimeout(function () {
          window.COW.unlock('7dd823bd-1762-45ce-ba99-b5ec8105855c', cowKeys);
        }, 7000);
      };
      $.post('/api/leads', $form.serialize())
        .done(function (lead) {
          afterLead();
        })
        .fail(function (error) {
          if (error.status == 422) {
            afterLead();
          } else {
            console.log('error!', error);
          }
        });
    });

    $('#the-cow').click(function () {
      $('#beamButton').addClass('shake');
      setTimeout(function () {
        $('#beamButton').removeClass('shake');
      }, 1000);
    });

    $('#holy-cow').click(function () {
      window.COW.unlock('b60c5f4d-a8ef-4b13-b02f-887c14e3efdf', cowKeys);
    });

    //bike cow
    $(
      'img[src="https://zurb-dot-com-prod.s3.amazonaws.com/asset/595/raw_2F87045029-930d-41f9-85d3-891c312f7dd3_2Fcow-design.png"]'
    ).click(function () {
      window.COW.unlock('46a491e1-0a19-46cd-b45f-99cb63409d39', cowKeys);
    });
  });
});
